import { render } from "./JobManagement.vue?vue&type=template&id=4b18a0ed"
import script from "./JobManagement.vue?vue&type=script&lang=js"
export * from "./JobManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__